import React, { useContext } from 'react';
import { Box, Text } from 'pcln-design-system';
import { MyTripsList } from './MyTripsList';
import { myTripContextData } from './myTripDataContext';
const TripsHeader = ({
  title,
  isRealTime
}) => React.createElement(Text, {
  fontWeight: 'bold',
  my: 2,
  color: isRealTime ? 'text.lightest' : 'text.dark'
}, title);
export const ListOfDifferentTrips = () => {
  const {
    currentTrips,
    upcomingTrips,
    pastTrips,
    canceledTrips
  } = useContext(myTripContextData);
  return React.createElement(React.Fragment, null, (currentTrips === null || currentTrips === void 0 ? void 0 : currentTrips.length) > 0 && React.createElement(React.Fragment, null, React.createElement(TripsHeader, {
    title: 'Your current trip'
  }), React.createElement(Box, {
    maxWidth: '450px'
  }, React.createElement(MyTripsList, {
    trips: currentTrips,
    tripCategory: 'currentTrips'
  }))), (upcomingTrips === null || upcomingTrips === void 0 ? void 0 : upcomingTrips.length) > 0 && React.createElement(React.Fragment, null, React.createElement(TripsHeader, {
    title: 'Upcoming trip(s)'
  }), React.createElement(Box, {
    maxWidth: '450px'
  }, React.createElement(MyTripsList, {
    trips: upcomingTrips,
    tripCategory: 'upcomingTrips'
  }))), (pastTrips === null || pastTrips === void 0 ? void 0 : pastTrips.length) > 0 && React.createElement(React.Fragment, null, React.createElement(TripsHeader, {
    title: 'Past trip(s)'
  }), React.createElement(Box, {
    maxWidth: '450px'
  }, React.createElement(MyTripsList, {
    trips: pastTrips,
    tripCategory: 'pastTrips'
  }))), (canceledTrips === null || canceledTrips === void 0 ? void 0 : canceledTrips.length) > 0 && React.createElement(React.Fragment, null, React.createElement(TripsHeader, {
    title: 'Cancelled trip(s)'
  }), React.createElement(Box, {
    maxWidth: '450px'
  }, React.createElement(MyTripsList, {
    trips: canceledTrips,
    tripCategory: 'canceledTrips'
  }))));
};